import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import User from '_class/User';
import FromNow from 'components/Presentation/Date/FromNow';
import Status from 'components/Presentation/Status';
import { ColorLabel, ColorLabelContainer } from 'UI';
import { Icon, Flex, translate } from '@haldor/ui';
import { Link } from 'react-router-dom';
import { getRootUrl } from 'helpers/url';

var DisplayAssignment = /*#__PURE__*/function (_Component) {
  _inherits(DisplayAssignment, _Component);

  var _super = _createSuper(DisplayAssignment);

  function DisplayAssignment() {
    var _this;

    _classCallCheck(this, DisplayAssignment);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderTeamsAssignment", function () {
      var assignment = _this.props.assignment;
      return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, assignment.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "assignment-meta"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FromNow, null, assignment.dueDateTime), /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: 5
        }
      }, /*#__PURE__*/React.createElement("span", null, "Teams")), _this.props.remove != null ? /*#__PURE__*/React.createElement("span", {
        className: "delete-resource",
        onClick: function onClick() {
          return _this.props.remove();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      })) : null)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderHaldorAssignment", function () {
      var _assignment$externalI;

      var _this$props = _this.props,
          translate = _this$props.translate,
          assignment = _this$props.assignment;
      var user = new User(_this.props.currentUser);
      var addedColorDots = [];
      return /*#__PURE__*/React.createElement(Flex, null, _this.props.useLink ? /*#__PURE__*/React.createElement(Link, {
        to: "".concat(getRootUrl(), "assignment/").concat((_assignment$externalI = assignment === null || assignment === void 0 ? void 0 : assignment.externalID) !== null && _assignment$externalI !== void 0 ? _assignment$externalI : assignment.id),
        className: "cardLink"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, assignment.courses != null && assignment.courses.length > 0 ? /*#__PURE__*/React.createElement(ColorLabelContainer, null, assignment.courses.map(function (course) {
        if (addedColorDots.find(function (t) {
          return t == course.id;
        }) == null) {
          var text = course.title;
          text = course.year != null ? text + ' ' + course.year : text;
          addedColorDots.push(course.id);
          return /*#__PURE__*/React.createElement(ColorLabel, {
            key: course.id,
            tooltip: text,
            color: course.colorCode
          });
        }
      })) : null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, assignment.title), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 'var(--size-14)'
        }
      }, assignment.section != null ? assignment.section.title : ''))) : /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, assignment.courses != null && assignment.courses.length > 0 ? /*#__PURE__*/React.createElement(ColorLabelContainer, null, assignment.courses.map(function (course) {
        if (addedColorDots.find(function (t) {
          return t == course.id;
        }) == null) {
          var text = course.title;
          text = course.year != null ? text + ' ' + course.year : text;
          addedColorDots.push(course.id);
          return /*#__PURE__*/React.createElement(ColorLabel, {
            key: course.id,
            tooltip: text,
            color: course.colorCode
          });
        }
      })) : null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, assignment.title), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 'var(--size-14)'
        }
      }, assignment.section != null ? assignment.section.title : '')), /*#__PURE__*/React.createElement("div", {
        className: "assignment-meta"
      }, /*#__PURE__*/React.createElement("div", null, assignment.status === 'ASSIGNMENT_LOCKED' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: 5
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Lock"
      }), _this.props.translate('Locked'), user.isTeacher() ? /*#__PURE__*/React.createElement(Fragment, null, ' ', (assignment === null || assignment === void 0 ? void 0 : assignment.lockedWorkspaces) === 0 ? 0 : assignment === null || assignment === void 0 ? void 0 : assignment.lockedWorkspaces, " /", ' ', assignment === null || assignment === void 0 ? void 0 : assignment.totalTasks) : null) : null, assignment.published == '0001-01-01T00:00:00' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, _this.props.translate('Draft')) : null, assignment.created != '0001-01-01T00:00:00' ? /*#__PURE__*/React.createElement(FromNow, null, assignment.dueDate) : null, assignment.assessmentId != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, _this.props.translate('assessed')) : null, assignment.externalID != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: 5
        }
      }, /*#__PURE__*/React.createElement("span", null, "Teams")) : assignment.created == '0001-01-01T00:00:00' ? /*#__PURE__*/React.createElement("span", {
        className: "badge-primary"
      }, _this.props.translate('task-is-creating')) : /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, /*#__PURE__*/React.createElement(Status, {
        type: "assignmentTypes",
        id: assignment.assignmentType
      })), _this.props.customPermission ? _this.props.remove != null && _this.props.permission ? /*#__PURE__*/React.createElement("span", {
        className: "delete-resource",
        onClick: function onClick() {
          return _this.props.remove();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      })) : null : _this.props.remove != null ? /*#__PURE__*/React.createElement("span", {
        className: "delete-resource",
        onClick: function onClick() {
          return _this.props.remove();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      })) : null), /*#__PURE__*/React.createElement("div", {
        className: "submission-info"
      }, assignment.submittedTasks != null && !user.isStudent() && assignment.totalTasks > 0 ? /*#__PURE__*/React.createElement("div", {
        "data-tooltip": translate('submitted-list-title') + ' ' + translate('tasks'),
        className: "card-meta"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block',
          width: 11,
          height: 19
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "File"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block',
          marginLeft: 7
        }
      }, translate('submitted-list-title'), " ", assignment.submittedTasks, " /", ' ', assignment.totalTasks)) : null, assignment.publishedAssessments != null && !user.isStudent() && assignment.totalTasks > 0 ? /*#__PURE__*/React.createElement("div", {
        "data-tooltip": translate('published-assessments'),
        className: "card-meta"
      }, translate('assessed-tasks'), " ", assignment.publishedAssessments) : null)));
    });

    return _this;
  }

  _createClass(DisplayAssignment, [{
    key: "render",
    value: function render() {
      if (this.props.assignment['@odata.type'] == 'haldor.assignment.block.teamsassignment') {
        return this.renderTeamsAssignment();
      }

      return this.renderHaldorAssignment();
    }
  }]);

  return DisplayAssignment;
}(Component);

function mapStateToProps(state) {
  return {
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(DisplayAssignment);